
    import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
    import BaseVue from '@/components/BaseVue'
    import { Pulldown } from '../models/Pulldown'
    import { RouteItem } from '../models/RouteItem'
    import { Authority } from '../models/Authority'
    import { CostDetail } from '../models/CostDetail'
    import { TrainPassData } from '../models/TrainPassData'
    import { LogData } from '../models/LogData'
    import { CostDetailSearchCondition } from '../models/CostDetailSearchCondition'
    import { CostRouteSearchCondition } from '../models/EkitanSearchCondition';
    import { StationInput } from '../models/StationInput';
    import StationTextField from '@/components/StationTextField.vue';
    import MoneyTextField from '@/components/MoneyTextField.vue';
    import ControlManager from '../scripts/ControlManager';
    import { TrainPassApplicationSearchCondition } from '../models/TrainPassApplicationSearchCondition'
    import { searchLowestForCost, search1stStation, searchRouteForCost, searchRouteForCostCommmuteRoute } from '../scripts/SearchEkitan'
    import { Const } from '../scripts/Const';
    import { MsgConst } from '../scripts/MsgConst';
    import { StringUtil } from '../scripts/StringUtil';
    @Component
        ({
            components: { StationTextField, MoneyTextField }
        })
    export default class SearchTransportCostDialog extends BaseVue {

        @Prop({ type: Boolean, required: true }) private showDialog!: boolean
        @Prop({ type: String }) private targetDate: string
        @Prop({ type: Number }) private detailNo: number
        @Prop({ type: String }) private empCd: string

        @Ref('scrollTarget') scrollTarget!: HTMLElement;
        @Ref('searchTransportCostSaveBtn') saveBtn!: Vue;
        @Ref('searchTransportCostDeleteBtn') deleteBtn!: Vue;
        @Ref('searchTransportCostSearchBtn') searchBtn!: Vue;
        @Ref('searchTransportCostLastConditionBtn') lastConditionBtn!: Vue;


        //コントロールごとの活性制御
        private controlManager = new ControlManager();

        //#region 変数
        private editCondition: CostDetail = new CostDetail()
        private lastSearchCondition: CostDetail = new CostDetail()
        private searchCondition: CostDetailSearchCondition = new CostDetailSearchCondition()
        private trainPassSearchCondition: TrainPassApplicationSearchCondition = new TrainPassApplicationSearchCondition()
        private trainPassData: TrainPassData = new TrainPassData()
        private receiptFile: []
        private authority: Authority = new Authority()
        private logs: LogData[] = []
        private notLowestFlg: boolean = false;

        private eventNm = ''

        //#region 最新駅検索条件
        private lastStartStation: StationInput = {
            text: '',
            cd: '',
        };
        private lastEndStation: StationInput = {
            text: '',
            cd: '',
        };
        private lastTransitStation: StationInput = {
            text: '',
            cd: '',
        };

        private lastStartTime = '';
        private lastOrderKbn = '';
        private lastRoundKbn = '';
        private lastAmount =0;
	    //#endregion

        //#region ファイルアップロード
        private uploadFileData: any = null;
        private uploadFile: any = null;
        private deleteFlg = false;
        //#endregion

        //駅候補検索タイマー
        private routes: RouteItem[] = []

        //#region 出発時刻
        get formattedTime(): string {
            if (this.editCondition.startTime) {
                return (this.editCondition.startTime).substring(0, 2) + ':' + (this.editCondition.startTime).substring(2, 4);
            }
            return '';
        }

        set formattedTime(value: string) {
            this.editCondition.startTime = value.replace(':', '');
        }
        //#endregion

        //#region 表示制御

        //#region フッターボタン
        private showSavebtn = true
        private showDeletebtn = true
        //#endregion

        private showDecisionRemarks = false

        //ログ
        private showLog = false

        //#endregion

        //#region メッセージ
        private showMessage = false
        private messageType = 'info'
        private message = ''
	    //#endregion

        //#region ガイダンス
        private showGuidance = false
        private guidanceType = 'info'
        private guidance = ''
	    //#endregion

        //#region プルダウン
        //経路区分

        private commuteRouteKbnList: Pulldown[] =
            [
                { nm: '通勤経路', cd: '01' },
                { nm: '通勤経路外', cd: '02' }
            ]
        //#endregion

        //#region 活性制御

        //通勤経路区分
        private disableCommuteRouteKbn: boolean = false;

        //フッターボタン
        private disableSavebtn: boolean = false;
        private disableDeletebtn: boolean = false;

        private disableCostAmount: boolean = false;
        //#endregion

        //#region ダイアログ
        private dialog = false
        private title = ''
        private dialogMsg = ''
	    //#endregion

        //#region プルダウン
        private costKbnList: Pulldown[] = []
	    //#endregion

        //決済理由
        private disabledecision = false
        private disableRemarks = false

	    //#endregion

        //#region  ヘッダー
        private headers = [
            {
                text: '',
                value: 'check',
                width: '2%',
                class: 'primary nowrap sticky-header sticky1 zindex4 white--text',
                align: 'center',
                sortable: false,

            },
            {
                text: '経路',
                value: 'passInfo',
                width: '80%',
                class: 'primary sticky-header nowRap white--text',
                align: 'center',
                sortable: false,
            },
            {
                text: '所要',
                value: 'time',
                width: '7%',
                class: 'primary nowrap sticky-header nowRap white--text',
                align: 'center',
                sortable: false,
            },
            {
                text: '料金',
                value: 'exceptCommuterFare',
                width: '7%',
                class: 'primary nowrap sticky-header nowRap white--text',
                align: 'center',
                sortable: false,
            }
        ]
	//#endregion

        //#region イベント

        //#region 初期表示
        private async created() {
            ////条件を設定する
            this.editCondition = new CostDetail()
            this.editCondition.targetDate = this.$route.params.workingDate
            this.editCondition.empCd = this.$route.params.empCd
        }

        //ダイアログが表示されたとき
        @Watch('showDialog', { immediate: true, deep: true })
        onShowDialogChanged(showDialog: boolean) {

            this.messageClear();

            this.initialize();

            if (showDialog === true) {

                //条件を設定する
                this.editCondition = new CostDetail()
                this.editCondition.targetDate = this.$route.params.workingDate
                this.editCondition.empCd = this.$route.params.empCd

                this.searchCondition.targetDate = this.targetDate;
                this.searchCondition.empCd = this.empCd;
                this.searchCondition.detailNo = this.detailNo;

                //経費情報の取得
                this.getCostDetail()
                
            }
        }
	    //#endregion

        //#region 検索ボタン押下
        private async clickSearchRoute() {

            this.messageClear();

            //駅名入力値をチェックする
            let resultValid = await this.isValidForSearchRoute();

            if (resultValid) {
                //経路を検索する

                //項目初期化
                this.routes = [];
                this.editCondition.costAmount = 0;
                this.editCondition.passKey = '';
                this.editCondition.passInfo = '';
                this.editCondition.lowestPrice = 0;
                this.editCondition.lowestInfo = '';
                this.notLowestFlg = false;

                //検索
                this.searchRoute();

            }

        }
        //#endregion

        //#region 経路選択
        private handleSpaceKey(item: RouteItem) {
            item.check = !item.check;
            this.onInputCheck(item);
        }

        private onInputCheck(item: RouteItem) {
            let checkedCount = 0
            this.notLowestFlg = false;

            for (const i of this.routes) {
                if (item.no != i.no) {
                    i.check = false;
                } else {

                    if (i.check) {
                        //金額と経路を登録条件に設定する
                        this.editCondition.costAmount = i.exceptCommuterFare;
                        this.lastAmount = this.editCondition.costAmount;
                        this.editCondition.passKey = i.commuterRegistKey;
                        this.editCondition.passInfo = i.passInfo;
                        this.editCondition.ifCommuteRoute = i.ifCommuteRoute;
                        checkedCount++;
                    }
                }
            }

            if (checkedCount === 0) {
                this.editCondition.costAmount = 0;
                this.lastAmount = 0;
                this.editCondition.passKey = '';
                this.editCondition.passInfo = '';
                this.editCondition.ifCommuteRoute = false;
            } else {
                this.checkisNotLowestRoute();
            }
        }
        //#endregion

        //#region 添付ファイルインプット　変更
        private async onChangeFile(selectedFile: any) {
            if (this.uploadFile == null) return;
            this.uploadFileData = new Object();
            this.uploadFileData.type = this.uploadFile.type;
            this.uploadFileData.fileName = this.uploadFile.name;

            this.readFileAsync(this.uploadFile)
                .then((result) => {
                    this.uploadFileData.data = result;
                })
        }
        //#endregion

        //#region 添付ファイルインプット　クリア
        private onClearFile() {
            this.uploadFile = null;
            this.uploadFileData = null;
        }
        //#endregion

        //#region 添付ファイル　リンク押下
        async downloadReceiptFile(fileName: string) {

            try {

                await this.$axios({
                    url: 'api/CostEntryDialog/DownloadReceiptFile',
                    method: 'GET',
                    params: {
                        fileName: fileName,
                        empCd: this.editCondition.empCd,
                        year: (this.targetDate).substring(0, 4),
                        month: (this.targetDate).substring(4, 6),
                        date: (this.targetDate).substring(6, 8),
                        detailNo: this.editCondition.detailNo.toString(),
                    },
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });

            } catch (error) {
                this.showMessage = true
                this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
                this.messageType = 'error'
            }
        }

        //#endregion

        //#region 登録ボタン押下
        private clickEdit() {

            this.messageClear();

            this.eventNm = 'edit'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_001, '経費明細'))

        }
        //#endregion

        //#region 削除ボタン押下
        private clickDelete() {

            this.messageClear();

            //確認ダイアログ
            this.eventNm = 'delete'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_017, '経費明細'))
        }
        //#endregion

        //#region　前回複写ボタン押下
        private clickGetLastCondition() {
            this.messageClear();

            //確認ダイアログ
            this.eventNm = 'getLastCondition'
            this.openDialog('確認', MsgConst.COST_DETAIL.CONFIRM_001)
        }
        //#endregion

        //#region 閉じるボタン押下
        closeSearchTransportCostDialog() {
            this.$emit('result', false);
        }
        //#endregion

        //#endregion

        //#region プライベートメソッド

        //#region 経費明細情報取得
        private async getCostDetail() {
            try {

                const data = {
                    SearchCondition: this.searchCondition
                }

                this.disableAllTarget();
                const response = await this.$axios.post('api/SearchTransportCostDialog/Get', data)
                this.restoreAllTarget();

                //webLogicのレスポンスにメッセージがある場合は表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (response.data.messageData.errFlg) {

                        //画面上部へスクロール
                        this.scrollToMessage();
                        return
                    }
                }

                //権限
                this.authority = response.data.authority
                //勤務時間
                if (response?.data?.editCondition !== undefined && response?.data?.editCondition !== null) {
                    this.editCondition = response.data.editCondition;
                    this.trainPassData = response.data.trainPass1stRoute;

                    //新規登録画面　同月の定期券申請にて「定期購入：なし」で登録済の場合
                    if (data.SearchCondition.detailNo === 0 && this.trainPassData.trainPassPurchaseFlg === false) {

                        //経路区分：通勤経路
                        this.editCondition.commuteRouteKbn = Const.TransPortCost.commuteRouteKbn.INSIDE;
                        //往復区分：往復
                        this.editCondition.roundKbn = Const.TransPortCost.roundKbn.ROUND_TRIP;
                        //定期申請情報の経路を設定する
                        this.setTrainPassRoute();
                    }
                    //ログ
                    this.logs = response.data.logList
                    //表示制御
                    this.displayShowControl();
                    this.displayDisableContorol();
                    //ガイダンスを表示する
                    this.getGuidance(response.data.editCondition.detailStatus);

                    //手入力でない経費明細の場合、経路を検索し、選択する
                    if (this.editCondition.passKey || this.editCondition.passInfo) {
                        this.selectRoute();
                    }
                }
                else {
                    this.initialize();
                }

                //画面上部へスクロール
                this.scrollToMessage();
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region 定期申請情報の経路を設定する
        private setTrainPassRoute() {

            //定期申請情報の経路を設定する
            this.editCondition.startStation        = this.trainPassData.startStation1     
            this.editCondition.endStation          = this.trainPassData.endStation1       
            this.editCondition.transitStation      = this.trainPassData.transitStation1
            this.editCondition.startStationCd      = this.trainPassData.startStation1Cd   
            this.editCondition.endStationCd        = this.trainPassData.endStation1Cd     
            this.editCondition.transitStationCd    = this.trainPassData.transitStation1Cd
            this.editCondition.passKey             = this.trainPassData.passKey1
            this.editCondition.passInfo            = this.trainPassData.trainPassInfo1

        }
        //#endregion

        //#region　経路区分変更
        private async changeCommuteRouteKbn(commuteRouteKbn: string) {
            try {
                
                if (commuteRouteKbn == '01') {
                    //経路選択

                    //画面項目クリア
                    this.clearDisplay();

                    //取得条件の設定
                    this.trainPassSearchCondition.empCd = this.searchCondition.empCd;
                    this.trainPassSearchCondition.ym = this.targetDate.substring(0, 6);

                    const data = {
                        SearchCondition: this.trainPassSearchCondition
                    }

                    //料金は往復デフォルト
                    this.editCondition.roundKbn = Const.TransPortCost.roundKbn.ROUND_TRIP

                    //更新ボタン系を非活性にする
                    this.disableAllTarget();

                    const response = await this.$axios.post('api/TrainPassApplication/Get', data)

                    this.trainPassData = response.data.editCondition;

                    //定期申請情報の経路を設定する
                    this.setTrainPassRoute();

                    //経路を選択する
                    await this.selectRoute();

                    //非活性制御を解放
                    this.restoreAllTarget();

                } else if (commuteRouteKbn == '02') {
                    //経路外選択

                    //画面項目クリア
                    this.clearDisplay();
                }
            } catch (e) {
                console.log(e.message)
            } finally {
                //非活性制御を解放
                this.restoreAllTarget();
            }
        }
        //#endregion

        //#region 経費明細　登録
        private async edit() {
            try {

                let isSelect = 0;
                for (const i of this.routes) {
                    if (i.check) {
                        isSelect++;
                    }
                }

                //経路選択の場合、最新の検索条件を駅に設定
                if ((this.editCondition.passKey || this.editCondition.passInfo) && isSelect) {
                    this.editCondition.startStation = this.lastStartStation.text;
                    this.editCondition.startStationCd = this.lastStartStation.cd;
                    this.editCondition.endStation = this.lastEndStation.text;
                    this.editCondition.endStationCd = this.lastEndStation.cd;
                    this.editCondition.transitStation = this.lastTransitStation.text;
                    this.editCondition.transitStationCd = this.lastTransitStation.cd;
                    this.editCondition.startTime = this.lastStartTime;
                    this.editCondition.orderKbn = this.lastOrderKbn;
                    this.editCondition.roundKbn = this.lastRoundKbn;
                    this.editCondition.costAmount = this.lastAmount;
                }
                else {
                    this.editCondition.startStationCd = '';
                    this.editCondition.endStationCd = '';
                    this.editCondition.transitStationCd = '';
                    this.editCondition.passKey = '';
                    this.editCondition.passInfo = '';
                    this.editCondition.lowestPrice = 0;
                    this.editCondition.lowestInfo = '';
                }

                let formData = new FormData()

                if (this.uploadFile != null) {
                    formData.append(
                        "file",//登録添付ファイル
                        new Blob([this.uploadFileData.data], { type: this.uploadFileData.type }),
                        this.uploadFileData.fileName
                    );
                }
                formData.append(
                    "data",//経費の登録情報
                    JSON.stringify(this.editCondition),
                )
                formData.append(
                    "fileDeleteFlg",//添付ファイル削除チェックONかどうか
                    JSON.stringify(this.deleteFlg),
                )

                this.disableAllTarget();
                const response = await this.$axios.post('api/SearchTransportCostDialog/Edit', formData)
                this.restoreAllTarget();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        //画面を初期化し再度読み込み
                        this.initialize()
                        this.searchCondition.targetDate = this.targetDate;
                        this.searchCondition.empCd = this.empCd;
                        this.searchCondition.detailNo = response.data.editResult.detailNo;
                        this.getCostDetail()
                        //親画面の経費一覧を再取得
                        this.$emit('update');
                        //画面上部へスクロール
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }
                    return
                }
                //ガイダンスを表示する
                this.getGuidance(response.data.editCondition.requestStatus)
                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })

            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region 経費明細　削除
        private async delete() {
            try {

                const data = {
                    EditCondition: this.editCondition,
                }

                this.disableAllTarget();
                const response = await this.$axios.post('api/SearchTransportCostDialog/delete', data)
                this.restoreAllTarget();
                
                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        //画面を更新不可にする
                        this.disableSavebtn = true;
                        this.disableDeletebtn = true;
                        //親画面の経費一覧を再取得
                        this.$emit('update');
                        //ガイダンス非表示
                        this.showGuidance = false
                        this.guidance = ''
                        //画面上部へスクロール
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }
                    return
                }
                //ガイダンスを表示する
                this.getGuidance(response.data.editCondition.requestStatus)
                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })

            } catch (e) {
                console.log(e.message)
            } finally {

            }
        }
        //#endregion

       　//#region 前回交通費の検索条件　取得
        private async getLastCondition() {
            try {

                const data = {
                    SearchCondition: this.searchCondition
                }

                this.disableAllTarget();
                const response = await this.$axios.post('api/SearchTransportCostDialog/GetLastCondition', data)
                this.restoreAllTarget();

                //webLogicのレスポンスにメッセージがある場合は表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (response.data.messageData.errFlg) {

                        //画面上部へスクロール
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                        return
                    }
                }

                //前回交通費
                if (response?.data?.editCondition !== undefined && response?.data?.editCondition !== null) {


                    //取得結果を画面項目へ反映
                    this.lastSearchCondition = response.data.editCondition;

                    this.editCondition.startTime           = this.lastSearchCondition.startTime          
                    this.editCondition.orderKbn            = this.lastSearchCondition.orderKbn           
                    this.editCondition.commuteRouteKbn     = this.lastSearchCondition.commuteRouteKbn    
                    this.editCondition.startStation        = this.lastSearchCondition.startStation       
                    this.editCondition.endStation          = this.lastSearchCondition.endStation         
                    this.editCondition.transitStation      = this.lastSearchCondition.transitStation     
                    this.editCondition.startStationCd      = this.lastSearchCondition.startStationCd     
                    this.editCondition.endStationCd        = this.lastSearchCondition.endStationCd       
                    this.editCondition.transitStationCd    = this.lastSearchCondition.transitStationCd   
                    this.editCondition.startTime           = this.lastSearchCondition.startTime
                    this.editCondition.roundKbn            = this.lastSearchCondition.roundKbn
                    this.editCondition.passInfo            = this.lastSearchCondition.passInfo
                    this.editCondition.passKey             = this.lastSearchCondition.passKey

                    //経路を検索する
                    this.selectRoute();
                    
                }
                else {
                    this.initialize();
                }

                //画面上部へスクロール
                this.scrollToMessage()
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region ガイダンスを表示する
        private getGuidance(detailStatus: string) {
            //何をすべきかガイダンスする
            this.showGuidance = false
            this.guidance = ''

            this.guidanceType = 'info'

            ////否認判定
            if (detailStatus == Const.CostDetailStatus.REMAND && this.showMessage == false) {
                this.guidanceType = 'error'
                this.guidance += MsgConst.COMMON.ERROR_001
                this.showGuidance = true
                return
            }

            //承認待ち判定
            if (detailStatus == Const.CostDetailStatus.AWAITING_APPROVAL) {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_002, '経費明細')
                this.showGuidance = true
                return
            }

            //承認済み判定
            if (detailStatus == Const.CostDetailStatus.APPROVED) {
                this.guidance = MsgConst.COST_DETAIL.INFO_001
                this.showGuidance = true
                return
            }

            //締済み判定
            if (detailStatus == Const.CostDetailStatus.CLOSING) {
                this.guidance = MsgConst.COMMON.INFO_004
                this.showGuidance = true
                return
            }

        }
        //#endregion

        //#region 画面項目初期化
        private initialize() {
            this.editCondition = new CostDetail();


            this.lastStartStation.cd = '';
            this.lastStartStation.text = '';
            this.lastEndStation.cd = '';
            this.lastEndStation.text = '';
            this.lastTransitStation.cd = '';
            this.lastTransitStation.text = '';
            this.lastStartTime = '';
            this.lastOrderKbn = '';
            this.lastRoundKbn = '';

            this.routes = [];

            this.editCondition.empCd = this.empCd;
            this.editCondition.targetDate = this.targetDate;
            this.disableCostAmount = false;
            this.deleteFlg = false;
            this.uploadFile = null;
            this.uploadFileData = null;

            this.notLowestFlg = false;
        }
        //#endregion

        //#region　画面入力項目初期化
        private clearDisplay() {
            this.lastStartStation.cd = '';
            this.lastStartStation.text = '';
            this.lastEndStation.cd = '';
            this.lastEndStation.text = '';
            this.lastTransitStation.cd = '';
            this.lastTransitStation.text = '';
            this.lastStartTime = '';
            this.lastOrderKbn = '';
            this.lastRoundKbn = '';

            this.clearRoute();

            this.disableCostAmount = false;
            this.deleteFlg = false;
            this.uploadFile = null;
            this.uploadFileData = null;

            this.notLowestFlg = false;
        }
        //#endregion

        //#region 画面項目の表示制御
        private displayShowControl() {

            //処理前にすべて非表示状態にする
            this.showSavebtn = false;
            this.showDeletebtn = false;
            this.showDecisionRemarks = false;

            //ログインユーザーまたは勤怠管理権限または管理職
            if (this.editCondition.empCd === this.authority.loginEmpCd || this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {

                if (this.editCondition.detailStatus === Const.CostDetailStatus.UNREGISTERED) {
                    this.showSavebtn = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.MAKING) {
                    this.showSavebtn = true;
                    this.showDeletebtn = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.REMAND) {
                    this.showSavebtn = true;
                    this.showDeletebtn = true;
                }
                if (this.editCondition.detailStatus === Const.CostDetailStatus.AWAITING_APPROVAL) {
                    this.showSavebtn = true;
                    this.showDeletebtn = true;
                }

            }

            //決裁理由
            if (this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {
                if (this.editCondition.detailStatus === Const.CostDetailStatus.MAKING
                    || this.editCondition.detailStatus === Const.CostDetailStatus.REMAND
                    || this.editCondition.detailStatus === Const.CostDetailStatus.APPROVED) {
                    this.showDecisionRemarks = true;
                }
            } else {
                if (this.editCondition.detailStatus === Const.CostDetailStatus.MAKING
                    || this.editCondition.detailStatus === Const.CostDetailStatus.REMAND
                    || this.editCondition.detailStatus === Const.CostDetailStatus.APPROVED) {
                    if (this.editCondition.decisionRemarks) {
                        this.showDecisionRemarks = true;
                    }
                }
            }
        }
        //#endregion

        //#region　画面項目の活性制御
        private displayDisableContorol() {
            //処理前にすべて非活性状態にする
            this.disableSavebtn = true;
            this.disableDeletebtn = true;

            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.UNREGISTERED) {
                this.disableSavebtn = false;
                this.disableDeletebtn = false;
            }
            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.MAKING) {
                this.disableSavebtn = false;
                this.disableDeletebtn = false;
            }
            if (this.editCondition.monthlyStatus === Const.CostMonthlyStatus.REMAND) {
                this.disableSavebtn = false;
                this.disableDeletebtn = false;
            }

            if (this.trainPassData.trainPassPurchaseFlg === true) {
                this.disableCommuteRouteKbn = true;
            }

        }
        //#endregion

        //#region メッセージクリア
        private messageClear() {
            this.message = ''
            this.showMessage = false
        }
        //#endregion

        //#region 子コンポーネントの戻り値を設定する
        //乗車駅
        updateTextStart(newText: string) {
            this.editCondition.startStation = newText;
        }
        updateCdStart(newCd: string) {
            this.editCondition.startStationCd = newCd;
        }
        //下車駅
        updateTextEnd(newText: string) { 
            this.editCondition.endStation = newText;
        }
        updateCdEnd(newCd: string) {
            this.editCondition.endStationCd = newCd;
        }
        //経由駅
        updateTextTransit(newText: string) {
            this.editCondition.transitStation = newText;
        }
        updateCdTransit(newCd: string) {
            this.editCondition.transitStationCd = newCd;
        }
        //#endregion

        //#region dialog
        //はい・いいえダイアログ
        private openDialog(title: string, msg: string) {
            this.title = title
            this.dialogMsg = msg
            this.dialog = true
        }
        //#endregion

        //#region ダイアログイベント
        private dialogEvent(reply: string) {
            this.avoidMultipost(async () => {
                if (reply == 'yes') {
                    //はいが押された場合
                    switch (this.eventNm) {
                        case 'edit':
                            this.edit()
                            break
                        case 'delete':
                            this.delete()
                            break
                        case 'getLastCondition':
                            this.getLastCondition()
                            break
                            break
                        default:
                            break
                    }
                } else {
                    //いいえが押された場合
                    switch (this.eventNm) {
                        default:
                            break
                    }
                }
                //ダイアログを閉じる
                this.dialog = false
                this.eventNm = ''
            })
        }
        //#endregion

        //#region 駅名入力チェック（検索ボタン）
        //Params="no"：経路の番号
        private async isValidForSearchRoute(): Promise<boolean> {

            //駅名未入力チェック
            if (!this.isEmptyStationText(this.editCondition.startStation, this.editCondition.endStation)) {
                return false;
            };

            if (!this.editCondition.startTime) {
                this.showMessage = true
                this.message = MsgConst.COST_DETAIL.ERROR_001;
                this.messageType = 'error'
                //画面上部へスクロール
                this.scrollToMessage();

                return false;
            }

            //駅名入力済かつ駅未選択の場合は検索し、駅を取得する
            if (!this.editCondition.startStationCd && this.editCondition.startStation) {
                const stationInfo = await search1stStation(this.editCondition.startStation, 1, this.editCondition.targetDate);

                //エラー発生の検証
                if (this.openAPImessage(stationInfo.message)) {
                    return false;
                }
                else if (!stationInfo.cd) {
                    this.showMessage = true
                    this.message = StringUtil.stringFormat(MsgConst.EKITAN.ERROR_003, '乗車駅')
                    this.messageType = 'error'
                    //画面上部へスクロール
                    this.scrollToMessage();

                    return false;
                };

                this.editCondition.startStationCd = stationInfo.cd;
                this.editCondition.startStation = stationInfo.text;
            }

            if (!this.editCondition.endStationCd && this.editCondition.endStation) {
                const stationInfo = await search1stStation(this.editCondition.endStation, 1, this.editCondition.targetDate);

                //エラー発生の検証
                if (this.openAPImessage(stationInfo.message)) {
                    return false;
                }
                else if (!stationInfo.cd) {
                    this.showMessage = true
                    this.message = StringUtil.stringFormat(MsgConst.EKITAN.ERROR_003, '下車駅')
                    this.messageType = 'error'
                    //画面上部へスクロール
                    this.scrollToMessage();

                    return false;
                };

                this.editCondition.endStationCd = stationInfo.cd;
                this.editCondition.endStation = stationInfo.text;
            }

            if (!this.editCondition.transitStationCd && this.editCondition.transitStation) {

                const stationInfo = await search1stStation(this.editCondition.transitStation, 1, this.editCondition.targetDate);

                //エラー発生の検証
                if (this.openAPImessage(stationInfo.message)) {
                    return false;
                }
                else if (!stationInfo.cd) {
                    this.showMessage = true
                    this.message = StringUtil.stringFormat(MsgConst.EKITAN.ERROR_003, '経由駅')
                    this.messageType = 'error'
                    //画面上部へスクロール
                    this.scrollToMessage();

                    return false;
                };

                this.editCondition.transitStationCd = stationInfo.cd;
                this.editCondition.transitStation = stationInfo.text;
            }
            
            return true;
        }

        private isEmptyStationText(startStation: string, endStation: string): boolean {

            if (!startStation) {
                this.messageClear();

                this.showMessage = true
                this.message = MsgConst.EKITAN.ERROR_004
                this.messageType = 'error'
                //画面上部へスクロール
                this.scrollToMessage();

                return false;
            }

            if (!endStation) {
                this.messageClear();

                this.showMessage = true
                this.message = MsgConst.EKITAN.ERROR_004
                this.messageType = 'error'
                //画面上部へスクロール
                this.scrollToMessage();

                return false;
            }

            return true
        }

        //#endregion

        //#region 経路　検索
        private async searchRoute() {

            try {

                let lowestInfo = { passInfo: '', price: 0, message: '' }

                //経路を検索する
                this.disableAllTarget();

                let searchCondition = this.setSearchParamsForCost();
                let searchCondiionLowest = this.setSearchParamsForCost();

                //最安値経路と経路一覧を取得
                if (this.trainPassData.trainPassPurchaseFlg === false && this.editCondition.commuteRouteKbn === Const.TransPortCost.commuteRouteKbn.INSIDE) {
                    //定期未購入　通勤経路の場合
                    [lowestInfo, this.routes] = await Promise.all([searchLowestForCost(searchCondiionLowest), searchRouteForCostCommmuteRoute(searchCondition)]);
                } else {
                    //その他
                    [lowestInfo, this.routes] = await Promise.all([searchLowestForCost(searchCondiionLowest), searchRouteForCost(searchCondition)]);
                }
                //最安値経路取得結果
                this.editCondition.lowestInfo = lowestInfo.passInfo;
                this.editCondition.lowestPrice = lowestInfo.price;
                this.restoreAllTarget();

                //エラー発生の検証
                if (this.routes.length == 0) {
                    this.clearRoute();
                    this.showMessage = true
                    this.message = MsgConst.EKITAN.ERROR_005
                    this.messageType = 'success'
                    //画面上部へスクロール
                    this.scrollToMessage();

                    return
                }
                else if (this.openAPImessage(this.routes[0].message) || (this.openAPImessage(lowestInfo.message))) {
                    this.clearRoute();
                    return;
                };

                //検索時の条件を保持する
                this.lastStartStation.cd = this.editCondition.startStationCd;
                this.lastStartStation.text = this.editCondition.startStation;
                this.lastEndStation.cd = this.editCondition.endStationCd;
                this.lastEndStation.text = this.editCondition.endStation;
                this.lastTransitStation.cd = this.editCondition.transitStationCd;
                this.lastTransitStation.text = this.editCondition.transitStation;
                this.lastStartTime = this.editCondition.startTime;
                this.lastOrderKbn = this.editCondition.orderKbn;
                this.lastRoundKbn = this.editCondition.roundKbn;

            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region 経路を検索し、登録情報を選択する
        private async selectRoute() {

            let checkRoute1Count = 0
            //経路1
            if (this.editCondition.passInfo) {
                await this.searchRoute();

                //経路情報から該当する経路を選択する
                for (const i of this.routes) {
                    if (i.passInfo === this.editCondition.passInfo) {

                        //選択
                        i.check = true;
                        this.editCondition.costAmount = i.exceptCommuterFare;
                        this.lastAmount = this.editCondition.costAmount;
                        this.editCondition.passKey = i.commuterRegistKey;
                        this.editCondition.passInfo = i.passInfo;
                        this.editCondition.ifCommuteRoute = i.ifCommuteRoute;
                        //最安値かどうか
                        this.notLowestFlg = this.isNotLowestRoute();
                        checkRoute1Count++;
                    }
                }
                //経路が見つからない場合、区間コードで選択する
                if (checkRoute1Count === 0) {
                    for (const i of this.routes) {
                        if (i.commuterRegistKey === this.editCondition.passKey) {

                            //選択
                            i.check = true;
                            this.editCondition.costAmount = i.exceptCommuterFare;
                            this.lastAmount = this.editCondition.costAmount;
                            this.editCondition.passKey = i.commuterRegistKey;
                            this.editCondition.passInfo = i.passInfo;
                            this.editCondition.ifCommuteRoute = i.ifCommuteRoute;
                            //最安値かどうか
                            this.notLowestFlg = this.isNotLowestRoute();
                        }
                    }
                }

            }
        }
        //#enderegion

	    //#endregion

        //#region 駅探API検索条件を設定する
        private setSearchParamsForCost(): CostRouteSearchCondition {

            let searchCondition = new CostRouteSearchCondition();

            searchCondition.startStationCd = this.editCondition.startStationCd;
            searchCondition.endStationCd     = this.editCondition.endStationCd;
            searchCondition.transitStationCd = this.editCondition.transitStationCd;
            searchCondition.targetDate = this.targetDate;
            searchCondition.targetTime = this.editCondition.startTime;
            searchCondition.orderKbn = this.editCondition.orderKbn;
            searchCondition.roundKbn = this.editCondition.roundKbn;
            searchCondition.passKey1 = this.trainPassData.passKey1;          
            searchCondition.passKey2 = this.trainPassData.passKey2;          
            searchCondition.passKey3 = this.trainPassData.passKey3;
            searchCondition.trainPassPurchaseFlg = this.trainPassData.trainPassPurchaseFlg;
            searchCondition.commuteRouteKbn = this.editCondition.commuteRouteKbn;

            return searchCondition
        };
        //#endregion

        //#region 選択中経路が最安値かどうか判定する
        checkisNotLowestRoute() {
            this.notLowestFlg = this.isNotLowestRoute();
        }

        private isNotLowestRoute(): boolean {

            if (this.editCondition.passInfo) {
                if (this.editCondition.costAmount !== this.editCondition.lowestPrice) {
                    return true
                }
                return false;
            }

            return false;
        }
        //#endregion

        //#region 経路を破棄
        private clearRoute() {

            this.routes = [];


            this.editCondition.passKey = '';
            this.editCondition.costAmount = 0;
            this.editCondition.startStation = '';
            this.editCondition.endStation = '';
            this.editCondition.transitStation = '';
            this.editCondition.startStationCd = '';
            this.editCondition.endStationCd = '';
            this.editCondition.transitStationCd = '';
            this.editCondition.passInfo = '';
            this.editCondition.ifCommuteRoute = false;


            this.lastStartStation.cd = '';
            this.lastStartStation.text = '';
            this.lastEndStation.cd = '';
            this.lastEndStation.text = '';
            this.lastTransitStation.cd = '';
            this.lastTransitStation.text = '';
        }
        //#endregion

        //#region　添付ファイルインプット　表示制御
        private get isShowFileInput(): boolean {
            if (!this.editCondition.receiptInfo) {
                return true;
            } else if (this.deleteFlg) {
                return true;
            }
            else {
                return false;
            }
        }
        //#endregion

        //#region　添付ファイルリンク　表示制御
        private get isShowFileLink(): boolean {
            if (this.editCondition.receiptInfo && this.deleteFlg === false) {
                return true;
            } else {
                return false;
            }
        }
        //#endregion

        //#region ファイルデータ読込
        private async readFileAsync(readFile: any) {

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                }

                reader.onerror = reject
                reader.readAsArrayBuffer(readFile)
            })
        }
        //#endregion

        //#region  駅探検索中エラーの検証
        private openAPImessage(message: string): boolean {

            if (message) {
                this.showMessage = true
                this.message = message
                this.messageType = 'error'

                //画面上部へスクロール
                this.scrollToMessage();
                return true
            }
            return false
        }
        //#endregion

        //#region 数値を三桁カンマで表示する
        private formatNumber(value: number) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        //#endregion

        //#region メッセージまでスクロールする
        private scrollToMessage() {
            if (this.scrollTarget) {
                this.scrollTarget.scrollIntoView({
                    behavior: 'smooth', // スムーズスクロール
                    block: 'center', // 要素を中央に配置
                    inline: 'nearest' // 横方向のスクロールを最小限に
                });
            }
        }
        //#endregion

        //#region 一時非活性対象すべてを一時非活性にする
        private disableAllTarget() {
            this.$nextTick(() => {
                this.controlManager.disableControl(this.saveBtn);
                this.controlManager.disableControl(this.searchBtn);
                this.controlManager.disableControl(this.saveBtn);
                this.controlManager.disableControl(this.deleteBtn);
                this.controlManager.disableControl(this.lastConditionBtn);
            });
        }
        //#endregion

        //#region 一時非活性対象すべてを一時非活性にする
        private restoreAllTarget() {
            this.$nextTick(() => {
                this.controlManager.restoreControl(this.saveBtn);
                this.controlManager.restoreControl(this.searchBtn);
                this.controlManager.restoreControl(this.saveBtn);
                this.controlManager.restoreControl(this.deleteBtn);
                this.controlManager.restoreControl(this.lastConditionBtn);
            });
        }
        //#endregion

        //#endregion

    }


